import Mustache from "mustache"
import { createEventListenerManager } from "shared/lib/utils.js"
import { loadUserRecentSearches } from "app/components/universal_search/search_history"
import { recommendationTemplate, searchHistoryTemplate } from "./templates"

const { addListener: addEventListenerWithCleanup, cleanup } = createEventListenerManager() as {
  addListener: (element: Element | Document, event: string, handler: EventListener) => void
  cleanup: (() => void) & { withPageRestore: (restoreFn: () => void) => void }
}

export const TOTAL_MAX_RECENT_SEARCHES = 4

// This component is responsible to load and display recent searches
export const RecentSearches = () => {
  const searchHistory = loadUserRecentSearches().slice(0, TOTAL_MAX_RECENT_SEARCHES)

  const populateRecentSearches = (searchHistory: string[]) => {
    document.querySelectorAll(".recent-searches").forEach(historyWrapper => {
      if (searchHistory.length > 0) {
        historyWrapper.classList.remove("hide")

        const historyList = historyWrapper.querySelector("ul.universal-search-helper-list")
        if (!historyList) return

        historyList.innerHTML = ""
        searchHistory.forEach(({ type, term, details }) => {
          const variables = {
            term,
            query_term: term.toLowerCase(),
            ...details,
          }

          const rendered = Mustache.render(
            type === "service" ? recommendationTemplate : searchHistoryTemplate,
            variables
          )
          historyList.insertAdjacentHTML("beforeend", rendered)
        })
      } else {
        historyWrapper.classList.add("hide")
      }
    })
  }

  if (document.querySelector("#explore-search")) {
    // Universal header doesn't need to update history since user will be redirected.
    addEventListenerWithCleanup(window, "search-history:updated", () => {
      populateRecentSearches(loadUserRecentSearches().slice(0, TOTAL_MAX_RECENT_SEARCHES))
    })
  }

  populateRecentSearches(searchHistory)

  cleanup.withPageRestore(() => {
    RecentSearches()
  })

  window.addEventListener("beforeunload", cleanup)
}
